// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-container {
    display: flex;
    flex-direction: row;
}

.contact-info {
    text-align: center;
}
.form-container {
    width: 50%;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.label {
    width: 100px;
    font-size: 14px;
    display: flex;
    justify-content: start;
}

.input {
    border: 1px solid #E7E7E7;
    border-radius: 20px;
    padding: 0.2rem;
    padding-left: 14px;
}

.button {
    border-radius: 20px; 
    width: 100%;
    border: none;
    padding: 5px;
}

.form-div {
    max-width: 300px;
}

.success-btn {
    border: 1.5px solid #FD7272;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .35s;
    width: 40px;
    height: 40px;
    background-color: #E7E7E7;
}

.success-btn svg{
    transform: translateY(-50%) rotate(720deg) scale(1);
}`, "",{"version":3,"sources":["webpack://./src/pages/contact/contact.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mDAAmD;AACvD","sourcesContent":[".contact-container {\n    display: flex;\n    flex-direction: row;\n}\n\n.contact-info {\n    text-align: center;\n}\n.form-container {\n    width: 50%;\n    padding: 3rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.label {\n    width: 100px;\n    font-size: 14px;\n    display: flex;\n    justify-content: start;\n}\n\n.input {\n    border: 1px solid #E7E7E7;\n    border-radius: 20px;\n    padding: 0.2rem;\n    padding-left: 14px;\n}\n\n.button {\n    border-radius: 20px; \n    width: 100%;\n    border: none;\n    padding: 5px;\n}\n\n.form-div {\n    max-width: 300px;\n}\n\n.success-btn {\n    border: 1.5px solid #FD7272;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all .35s;\n    width: 40px;\n    height: 40px;\n    background-color: #E7E7E7;\n}\n\n.success-btn svg{\n    transform: translateY(-50%) rotate(720deg) scale(1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
